










import { Component, Vue, Prop } from 'vue-property-decorator';
import DialogWrapper from './dialog-wrapper.vue';

@Component({
  components: { DialogWrapper }
})
export default class Notification extends Vue {
  @Prop() title!: string;
  @Prop() message!: string;
  @Prop() resolveFn!: (
    value?: boolean | PromiseLike<boolean> | undefined
  ) => void;

  ok() {
    this.resolveFn(true);
    this.close();
  }

  close() {
    this.$destroy();
    this.$el.remove();
  }
}
